import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_LOCALE, MatOptionModule, MatPseudoCheckboxModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { I18NextModule, I18NextService } from 'angular-i18next';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AumExpansionPanel, AumExpansionPanelOptions } from './accordion/expansion-panel';
import {
    AumExpansionActions,
    AumExpansionDraggingHolder,
    AumExpansionPanelHeader,
    AumExpansionPanelIndex,
    AumExpansionPanelTitle,
} from './accordion/expansion-panel-header';
import {
    AumExpansionPanelInformation,
    AumExpansionPanelInformationButton,
} from './accordion/expansion-panel-information-i';

import { AumActionHeader } from './action-header/action-header';
import { AumBreadcrumbModule } from './breadcrumb/breadcrumb-module';
import { AumButton } from './button/button';
import { AumDialogModule } from './dialog/dialog-module';
import { AumDraggableMultiSelect } from './formControls/aum-draggable-multi-select/aum-draggable-multi-select';
import { AumDateInput } from './formControls/aumDateInput/aum-dateinput';
import { AumicoNumberInputComponent } from './formControls/aumFormField';
import { AumFormError, AumFormField, AumFormFieldLabel } from './formControls/aumFormField/aum-form-field';
import { AumInput } from './formControls/aumFormField/aum-input';
import { NumberInputComponent } from './formControls/aumFormField/number-input/number-input';
import { AumPasswordInput } from './formControls/aumPasswordInput/aum-password-input';
import { AumSearch } from './formControls/aumSearchInput/aum-search';
import { AumSelect } from './formControls/aumSelect/aum-select';
import { AumTextarea } from './formControls/aumTextarea/aum-textarea';
import { AumToggle } from './formControls/aumToggle/aum-toggle';
import { AumMenuItemPerRowComponent } from './menu/aum-menu-item-per-row/aum-menu-item-per-row.component';
import { AumMenu } from './menu/menu';
import { AumNotificationToast } from './notification-toast/notification-toast';
import { AumPaginationActionBar } from './pagination-action-bar/pagination-action-bar';
import { AumPagination } from './pagination/pagination';
import { AumStepHeader } from './progress-indicators/aum-step-header';
import { AumHorizontalStepper, AumStep } from './progress-indicators/horizontal-stepper';

export function matDateLocaleFactory(i18nextService: I18NextService): string {
    return i18nextService.language;
}

const EXPORTED_DECLARATIONS = [
    AumButton,
    AumExpansionPanelHeader,
    AumExpansionPanelTitle,
    AumExpansionPanelIndex,
    AumExpansionDraggingHolder,
    AumExpansionActions,
    AumExpansionPanelInformation,
    AumExpansionPanelInformationButton,
    AumExpansionPanelOptions,
    AumExpansionPanel,
    AumPagination,
    AumPagination,
    AumStep,
    AumHorizontalStepper,
    AumStepHeader,
    AumPagination,
    AumPaginationActionBar,
    AumActionHeader,
    AumFormField,
    AumFormFieldLabel,
    AumFormError,
    AumInput,
    NumberInputComponent,
    AumicoNumberInputComponent,
    AumSelect,
    AumTextarea,
    AumToggle,
    AumDateInput,
    AumSearch,
    AumPasswordInput,
    AumMenu,
    AumDraggableMultiSelect,
    AumNotificationToast,
    AumMenuItemPerRowComponent,
];

@NgModule({
    declarations: [EXPORTED_DECLARATIONS],
    providers: [{ provide: MAT_DATE_LOCALE, useFactory: matDateLocaleFactory, deps: [I18NextService] }],
    imports: [
        CommonModule,
        I18NextModule,
        RouterModule,
        PortalModule,
        CdkAccordionModule,
        MatPseudoCheckboxModule,
        MatButtonModule,
        MatRippleModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        NgxMatSelectSearchModule,
        MatOptionModule,
        MatTabsModule,
        AumBreadcrumbModule,
        MatIconModule,
        MatStepperModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        AumDialogModule,
        DragDropModule,
        NgbToastModule,
        MatDialogModule,
    ],
    exports: [EXPORTED_DECLARATIONS, AumBreadcrumbModule, AumDialogModule],
})
export class AumicoPatternModule {}
